import React from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';

import { UIState } from '@/model/global/types';
import { WalletPageLink } from '@/pages/demo/components';
import { TransactionsPageView } from '@/pages/wallets/components';

export const TransactionsPage: React.FC<RouteComponentProps> = ({ location }) => {
  const scrollToTx = location.hash.replace('#', '');
  return (
    <TransactionsPageView back={WalletPageLink} basePath={UIState.WITHDRAWAL} withRecharge scrollToTx={scrollToTx} />
  );
};

export default withRouter(TransactionsPage);
